var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4"},[(_vm.canRead)?_c('EditLocales'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }